/* Lucky Feet: brand size chart dialog (native <dialog>, keyboard + screen-reader friendly) */
(function () {
  var lastTrigger = null;
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-lf-size-chart-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('data-lf-size-chart-open'));
      if (!dlg) return;
      e.preventDefault();
      lastTrigger = open.getAttribute('data-lf-size-chart-open');
      open.focus(); /* so the browser's own focus restore lands on the trigger */
      if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      document.documentElement.classList.add('lf-dialog-open');
      var close = dlg.querySelector('[data-lf-size-chart-close]');
      if (close) close.focus();
      return;
    }
    if (e.target.closest('[data-lf-size-chart-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    /* click on backdrop */
    if (e.target.matches && e.target.matches('dialog.lf-size-chart')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });
  document.addEventListener('close', function (e) {
    if (!e.target.matches || !e.target.matches('dialog.lf-size-chart')) return;
    document.documentElement.classList.remove('lf-dialog-open');
    /* trigger may have been re-rendered by a variant change, so look it up again */
    if (lastTrigger) {
      var id = lastTrigger;
      setTimeout(function () {
        var t = document.querySelector('[data-lf-size-chart-open="' + id + '"]');
        if (t && document.activeElement !== t) t.focus();
      }, 0);
    }
  }, true);
})();

/* Lucky Feet: show the stock count on the Size row ("Size: 7 · 2 in stock", Size chart on the right)
   instead of on its own line. The theme keeps updating its own inventory block, which stays in the
   DOM but is hidden; this mirrors its text and state into the size legend after every variant change. */
(function () {
  var css = document.createElement('style');
  css.textContent =
    '.product-inventory.lf-inv-moved{display:none!important}' +
    '.lf-inv-inline{display:inline-flex;align-items:center;gap:6px;margin-left:14px;font-size:13px;font-weight:600;color:var(--green-700,#2f5a1c);white-space:nowrap;vertical-align:baseline}' +
    '.lf-inv-inline::before{content:"";width:7px;height:7px;border-radius:50%;background:currentColor;flex:none}' +
    '.lf-inv-inline.is-low{color:#a84b08}' +
    '.lf-inv-inline[hidden]{display:none}';
  document.head.appendChild(css);

  function sync(form) {
    var inv = form.querySelector('.product-inventory');
    var sel = form.querySelector('.option-selector[data-option*="size" i], .option-selector[data-option*="taille" i]');
    var legend = sel && sel.querySelector('legend');
    if (!inv || !legend) return;
    if (!inv.classList.contains('lf-inv-moved')) inv.classList.add('lf-inv-moved');
    var mirror = legend.querySelector('.lf-inv-inline');
    if (!mirror) {
      mirror = document.createElement('span');
      mirror.className = 'lf-inv-inline';
    }
    /* the theme rewrites the "Size: 7" value inside the legend; keep the stock count after it */
    if (mirror.parentNode !== legend || legend.lastChild !== mirror) legend.appendChild(mirror);
    var status = inv.querySelector('.product-inventory__status');
    var text = (status ? status.textContent : inv.textContent).replace(/\s+/g, ' ').trim();
    var hide = inv.hidden || !text;
    var low = inv.className.indexOf('--low') !== -1;
    if (mirror.textContent !== text) mirror.textContent = text;
    if (mirror.hidden !== hide) mirror.hidden = hide;
    if (mirror.classList.contains('is-low') !== low) mirror.classList.toggle('is-low', low);
  }

  function syncAll() {
    document.querySelectorAll('form[action*="/cart/add"], .product-form').forEach(function (f) {
      var root = f.closest('.product-form') || f;
      sync(root);
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; syncAll(); });
  }

  function start() {
    syncAll();
    new MutationObserver(queue).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'class'], characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
